import type { ScheduleDensity } from '../scheduleDensity.js';

const DENSITIES: Array<{ value: ScheduleDensity; label: string }> = [
  { value: 'comfortable', label: 'Comfortable' },
  { value: 'compact', label: 'Compact' },
];

/**
 * 318 (FR-001, FR-009) — row density, a radio group like the View switch. It sits on the line under
 * the toolbar, beside "Reorder cars" (the other view preference), so the controls line keeps
 * fitting one row at desktop width (316 FR-020). Changing it refetches nothing.
 */
export function DensityToggle({
  density,
  onDensity,
}: {
  density: ScheduleDensity;
  onDensity: (density: ScheduleDensity) => void;
}) {
  return (
    <div
      role="radiogroup"
      aria-label="Row density"
      data-testid="schedule-density"
      className="flex shrink-0 rounded border border-hairline"
    >
      {DENSITIES.map((d) => (
        <button
          key={d.value}
          type="button"
          // biome-ignore lint/a11y/useSemanticElements: #950 a segmented control: buttons with role="radio" in a radiogroup is the ARIA pattern; native radio inputs would change the look and focus behaviour
          role="radio"
          aria-checked={density === d.value}
          onClick={() => density !== d.value && onDensity(d.value)}
          className={[
            'whitespace-nowrap px-2 py-0.5 text-xs first:rounded-l last:rounded-r',
            density === d.value ? 'bg-primary text-on-primary' : 'bg-canvas text-ink',
          ].join(' ')}
        >
          {d.label}
        </button>
      ))}
    </div>
  );
}
